import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

const login = (accessToken, refreshToken) => accessToken && refreshToken;

export function ProtectedRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        login(localStorage.getItem('accessToken'), localStorage.getItem('refreshToken')) ? (
          <Component {...rest} {...props} />
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: props.path } }} />
        )
      }
    />
  );
}

export function LoginRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        login(localStorage.getItem('accessToken'), localStorage.getItem('refreshToken')) ? (
          <Redirect to={{ pathname: '/', state: { from: props.path } }} />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
}

ProtectedRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  path: PropTypes.string.isRequired,
};

LoginRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  path: PropTypes.string.isRequired,
};
